module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-trial1-if-both-wrong.e6092389.mp3";